import { jsxs as e, jsx as l } from "react/jsx-runtime";
const n = ({ width: o, height: r, className: t }) => /* @__PURE__ */ e(
  "svg",
  {
    className: t,
    fill: "none",
    height: r,
    viewBox: "0 0 40 41",
    width: o,
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ l(
        "circle",
        {
          cx: "20",
          cy: "20.2176",
          fill: "currentColor",
          r: "20"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          d: "M22.2489 19.7282L16.2673 14.2061C15.825 13.7974 15.825 13.1365 16.2673 12.7321C16.7097 12.3234 17.4251 12.3277 17.8674 12.7321L24.6443 18.9891C25.0726 19.3847 25.082 20.0196 24.6773 20.4283L17.8721 26.7287C17.6509 26.9331 17.3592 27.0331 17.0721 27.0331C16.785 27.0331 16.4932 26.9331 16.272 26.7287C15.8297 26.32 15.8297 25.6591 16.272 25.2547L22.2489 19.7282Z",
          fill: "white"
        }
      )
    ]
  }
);
export {
  n as Content
};
